/**
 * 注意：web 的翻译获取机制与更新机制和pc实现不同，是直接获取本项目中的语言文件
 * 语言包的数据结构和pc是一致的
 * 之所以用这种方式
 *  - 一是web的更新自身就满足动态的概念，
 *  - 二是加载更为快速，pc的api方式，还需要走后台服务器
 *  - 第三方sdk，需要语言包直接跟着项目走。
 * 目前的语言更新方式
 *  1. 更新 resource/langs 目录中的相关文件
 *  2. 编译发版web
 */

const supportLocales = require('../resource/langs/i18n/locales').default;
import langManifest from '../resource/langs/manifest.json';
import _ from 'lodash';
import Emitter from '../services/emitter';
import CONSTANT from '../constant';
import config from '../config';
import Storage from '../services/api/store';

const path = require('path');
const APP_LANG_ROOT = path.join(config.appRootPath, 'langs');

const zhMessages = Object.assign(
    {},
    require('./i18n/zh.json'),
    require('./i18n/calibrate/zh.json'),
    require('./i18n/feedback/zh.json'),
    require('./i18n/updater/zh.json'),
    require('./i18n/example/zh.json'),
    require('./i18n/connect/zh.json'),
    require('./i18n/hardware/zh.json'),
    require('./i18n/hardwaredriver/zh.json'),
    require('./i18n/exts/zh.json'),
    require('./i18n/sprite/zh.json'),
    require('./i18n/project/zh.json'),
    require('./i18n/agreement/zh.json')
);

const enMessages = Object.assign(
    {},
    require('./i18n/en.json'),
    require('./i18n/calibrate/en.json'),
    require('./i18n/feedback/en.json'),
    require('./i18n/updater/en.json'),
    require('./i18n/example/en.json'),
    require('./i18n/connect/en.json'),
    require('./i18n/hardware/en.json'),
    require('./i18n/hardwaredriver/en.json'),
    require('./i18n/exts/en.json'),
    require('./i18n/sprite/en.json'),
    require('./i18n/project/en.json'),
    require('./i18n/agreement/en.json')
);

const projectId = 'mblock5-i18n';
const mscratchId = 'mscratch-i18n';
const supportLangs = langManifest.supportLangs;

const localeData = {
    en: {
        name: supportLangs.en.name,
        locale: supportLocales.en,
        messages: enMessages
    },
    zh: {
        name: supportLangs.zh.name,
        locale: supportLocales.zh,
        messages: zhMessages
    },
};

const supportLangKeys = Object.keys(supportLangs);
const readyLangKeys = Object.keys(localeData);

window.supportLocales = supportLocales;
window.locales = localeData;

const fetchLangData = lang => {
    const langUrl = `${APP_LANG_ROOT}/i18n/${lang}.json`;
    return fetch(langUrl)
        .then(data => data.json());
};

const updateLocaleData = lang => {
    return new Promise((res, rej) => {
        if (lang) {
            lang = lang.toLowerCase();
            if (lang === 'zhhant') {
                lang = 'zh-hant';
            }
        }
        if (localeData[lang]) {
            res();
            return;
        }
        try {
            if (Object.keys(supportLangs).includes(lang)) {
                fetchLangData(lang).then(msg => {
                    if (msg && typeof msg === 'object') {
                        localeData[lang] = {
                            name: supportLangs[lang].name,
                            locale: supportLocales[lang],
                            messages: msg[projectId] || enMessages,
                            mscratchMsgs: msg[mscratchId]
                        };
                        Emitter.emit('LocaleDataUpdated', lang, localeData[lang]);
                    }
                    res();
                });
            }
        } catch (err) {
            console.warn(lang, ' 语言获取失败：', err);
            rej();
        }
    });
};

/**
 * 获取系统浏览器语言
 *
 * @returns
 */
const getNavigatorLang = () => {
    if (!_.isEmpty(navigator.languages)) {
        if (navigator.languages[0].split('-')[0] === 'zh' && navigator.languages[0] !== 'zh-CN') {
            return 'zh-hant';
        }
        return navigator.languages[0].split('-')[0];
    }
    if (!_.isEmpty(navigator.language)) {
        if (navigator.language.split('-')[0] === 'zh' && navigator.language !== 'zh-CN') {
            return 'zh-hant';
        }
        return navigator.language.split('-')[0];
    }
    return 'en';
};

/**
 * 获取默认语言
 * @param langs array app支持的语言列表
 * @returns string
 */

const getDefaultLang = (langs = readyLangKeys) => {
    const storeLang = Storage.get(CONSTANT.INTL_LANG_KEY);
    if (storeLang && langs.includes(storeLang)) {
        return storeLang;
    }
    const navigatorLang = getNavigatorLang();
    if (navigatorLang && langs.includes(navigatorLang)) {
        return navigatorLang;
    }
    return langs[0];
};

export {
    localeData as default,
    updateLocaleData,
    supportLangs,
    supportLangKeys,
    readyLangKeys,
    getNavigatorLang,
    getDefaultLang
};